
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/snerapport",
      function () {
        return require("private-next-pages/[region]/[resort]/snerapport.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/snerapport"])
      });
    }
  